import PropTypes from "prop-types"
import React from "react"
import { Card, CardBody, Container } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"
// import LiveCallsStatsTable from "./LiveCallsStatsTable"
// import SystemCallsStatsTable from "./SystemCallsStatsTable"
// import ColdCallStatsTable from "./ColdCallStatsTable"
// import UserWiseVerificationCallStatsTable from "./UserWiseVerificationCallStatsTable"
// import UserWiseLiveColdStatsTable from "./UserWiseLiveColdStatsTable"
// import UserWiseSysGenratedCallStatsTable from "./UserWiseSysGenratedCallStatsTable"

import TodaysTelecallerPerformanceTable from "./TodaysTelecallerPerformanceTable"
import TodaysVerifierPerformanceTable from "./TodaysVerifierPerformanceTable"


const TodaysUserPerformance = props => {
  //meta title
  document.title = "Cockpit"

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Users")}
            breadcrumbItem={props.t("Todays User Performance")}
          />

          <Card>
            <CardBody className="border-bottom">
              <div style={{ padding: '20px' }}>
                {/* <LiveCallsStatsTable />
                <SystemCallsStatsTable />
                <ColdCallStatsTable /> */}
                <TodaysTelecallerPerformanceTable />
                <TodaysVerifierPerformanceTable/>
                {/* <UserWiseLiveColdStatsTable />
                <UserWiseSysGenratedCallStatsTable /> */}
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

TodaysUserPerformance.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(TodaysUserPerformance)
